export interface Report {
    id: string;
    start: string;
    end: string;
}
export interface InOut {
    in: string;
    out: string;
    modifiedIn?: string;
    modifiedOut?: string;
    modifiedInNotes?: string;
    modifiedOutNotes?: string;
    inUserAgent?: string;
    outUserAgent?: string;
    inLocation?: [number, number, number];
    outLocation?: [number, number, number];
    duration?: number;
    break?: boolean;
    notes?: string;
    reports?: Report[];
    /** manually added entry flag */
    m?: boolean;
}
export interface DayForm {
    inOut: InOut[];
    notes: string;
    regular?: number;
    ot?: number;
    date?: string;
}

export const timeCardStatus = ["Not Created", "Created",  "Submitted", "Approved", "Rejected"];
export type TimeCardStatus = "Not Created" | "Created" | "Submitted" | "Approved" | "Rejected";
export interface ReportListItem {
    value: string;
    label: string;
    startDate?: string;
    endDate?: string;
}
export interface LoaderData {
    data: JobTagForm;
    reportsList: ReportListItem[];
    working: boolean;
    week: string, 
    weeks: string[]
}
export interface JobTagForm {
    userId: string;
    userName: string;
    hireDate: string;
    quitDate?: string;
    outside?: string;
    week: string;
    form: DayForm[];
    status: TimeCardStatus;
    comments?: string;
    pdfId?: string;
}
export interface ListLoaderData {
    users: { userId: string; userName: string; status: TimeCardStatus }[];
    week: string;
    weeks: string[];
    status: string;
    total: number;
}
export interface DetailLoaderData {
    data: JobTagForm;
    reportsList: ReportListItem[];
    week: string;
}
export function weeknum(date: Date = new Date()): string {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    // ISO 8601: week starts Monday, shift Sunday (0) to end of week
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const isoYear = d.getUTCFullYear();
    const yearStart = new Date(Date.UTC(isoYear, 0, 1));
    const isoWeek = Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
    // Pad week to 2 digits, matching PHP "oW" e.g. "202509"
    return `${isoYear}${String(isoWeek).padStart(2, "0")}`;
}
export function getDatefromWeekNum(week: string, dayIndex: number): string {
    // week = "202509", dayIndex: 0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun
    const year  = parseInt(week.slice(0, 4));
    const weekN = parseInt(week.slice(4, 6));
    // Jan 4 is always in ISO week 1
    const jan4   = new Date(year, 0, 4);
    const monday = new Date(jan4);
    monday.setDate(jan4.getDate() - ((jan4.getDay() + 6) % 7) + (weekN - 1) * 7);
    const target = new Date(monday);
    target.setDate(monday.getDate() + dayIndex);
    const y = target.getFullYear();
    const m = String(target.getMonth() + 1).padStart(2, "0");
    const d = String(target.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`; // e.g. "2025-03-03"
}
export function getDevice(userAgent: string = navigator.userAgent): "Mobile" | "Mac" | "Windows" | "Other" {
    if (/android|iphone|ipad|ipod|mobile/i.test(userAgent)) return "Mobile";
    if (/mac/i.test(userAgent))                               return "Mac";
    if (/windows/i.test(userAgent))                           return "Windows";
    return "Other";
}